const SET_STATUS = 'SET_STATUS';
const SET_USER_SUCCESS = 'SET_USER_SUCCESS';

export const userActions = {
  SET_USER_SUCCESS,
  SET_STATUS,
};
